<div class="overflow-y-auto h-[85vh] mx-5 mb-5  pr-5 mr-0">
    
    <div class="bg-white rounded-2xl">
      <span class="join gap-2 relative w-full">
        <app-dashboard-page-header [platformName]="'facebook'" (selectedDateRange)="updateStats($event)" [hasNoPages]="facebookPageIds.length==0 || facebookPageIds.length==0 && !isInsightsLoading"/>
      </span>
    </div>
		
    <div class=" bg-white my-5 py-2 rounded-xl p-5">
			<h3 class="font-bold ml-5 py-4 text-xl block" [ngClass]="{'animate-pulse':isInsightsLoading && facebookPageIds.length>0}">{{'pageInsights.labels.general'|translate}}</h3>
			<div class="flex flext-wrap gap-2 w-full pb-3" >
				<app-widget-stats *ngFor="let item of GetGeneralData()" class=" w-[20%] " [data]="item" [source]="'facebook'" [isLoading]="isInsightsLoading && facebookPageIds.length>0" />
				</div>
			</div>
			
			<div class=" bg-white my-5 py-2 rounded-xl p-5">
				<h3 class="font-bold ml-5 py-4 text-xl block" [ngClass]="{'animate-pulse':isInsightsLoading && facebookPageIds.length>0}">{{'pageInsights.labels.indicators'|translate}}</h3>
				<div class="flex flext-wrap gap-2 w-full pb-3" >
				<app-widget-stats *ngFor="let item of GetIndicatorsData()" class=" w-[20%] " [data]="item" [source]="'facebook'" [isLoading]="isInsightsLoading && facebookPageIds.length>0" />
			</div>
	  </div>

    <div class=" bg-white my-5 py-2 rounded-xl p-5">
			<h3 class="font-bold ml-5 py-4 text-xl block" [ngClass]="{'animate-pulse':isInsightsLoading && facebookPageIds.length>0}">{{'pageInsights.labels.audience'|translate}}</h3>
			<div class="flex flext-wrap gap-2 w-full pb-3" >
				<app-widget-stats *ngFor="let item of GetAudienceData()" class=" w-[20%] " [data]="item" [source]="'facebook'" [isLoading]="isInsightsLoading && facebookPageIds.length>0" />
			</div>
	  </div>

 
  <!-- delete this part -->
  <div *ngIf="facebookPageIds.length>0" class="bg-white h-[82vh] my-5 py-5 relative flex items-end rounded-2xl">
		<div class="rounded-2xl h-[80vh] overflow-hidden absolute w-full">
      <app-posts-library [dashboard]="true" [dashboardSource]="'facebook'" [currentPostsTypeFilter]="{isPosted:true,isPlanned:true}" [currentPlaTformsFilters]= "{isFacebookON: true, isLinkedinON: false, isGoogleON: false, isInstagramON: false}"/>
    </div>
  </div>
  <!-- end delete -->

</div>

